import { render, staticRenderFns } from "./ItemN_Packaging.vue?vue&type=template&id=7a6822df"
import script from "./ItemN_Packaging.vue?vue&type=script&lang=js"
export * from "./ItemN_Packaging.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports